import {
  CreepType,
  CREEP_OPERATOR,
  CREEP_COMMANDER,
  CREEP_EXECUTOR
} from '../creep/creep.enum';

import { OPERATOR_SKILLS } from './skills.operator';
import { COMMANDER_SKILLS } from './skills.commander';
import { EXECUTOR_SKILLS } from './skills.executor';

import { Skill } from '../creep-skill';
import { Creep } from '../creep/creep';

export class Skills {
  private _creepRef: Creep;

  /**
   * @param {string} typeSkillsStr
   * @returns {Skills}
   */
  static fromString(typeSkillsStr: string) {
    const creepType: CreepType = parseInt(typeSkillsStr[0], 10);
    const skillsStrs: string[] = typeSkillsStr.substring(1).match(/.{2}/g) || [];

    const skills = skillsListByCreepType(creepType);

    skillsStrs.forEach((skillStr) => {
      const idx = parseInt(skillStr[0], 30);
      const level = parseInt(skillStr[1], 10);

      if (skills[idx]) {
        skills[idx].level = level;
      }
    });

    return new Skills(skills);
  }

  /**
   * @param {Skill[]} items
   */
  constructor(
    private items: Skill[] = []
  ) {
  }

  toString(): string {
    return this.items.reduce((skillsStr: string, { level }, idx: number) => {
      if (level) {
        skillsStr += `${ idx.toString(30) }${ level }`;
      }

      return skillsStr;
    }, '');
  }

  /**
   * @returns {Skill[]}
   */
  toArray(): Skill[] {
    return [...this.items];
  }

  /**
   * @returns {Creep}
   */
  get creepRef() {
    return this._creepRef;
  }

  /**
   * @param creepRef
   */
  set creepRef(creepRef) {
    this._creepRef = creepRef;

    this.items.forEach((skill) => {
      skill.creepRef = creepRef;
    });
  }
}

// Local helpers.
/**
 * @param skillList
 * @returns {Skill}
 */
function copy(skillList): Skill[] {
  return skillList.map(({ name, desk, requiresLevel }) => {
    return new Skill(name, desk, 0, requiresLevel);
  });
}

/**
 * @param {CreepType} creepType
 * @returns {Skill[]}
 */
function skillsListByCreepType(creepType: CreepType): Skill[] {
  if (creepType === CREEP_OPERATOR) {
    return copy(OPERATOR_SKILLS);
  }

  if (creepType === CREEP_COMMANDER) {
    return copy(COMMANDER_SKILLS);
  }

  if (creepType === CREEP_EXECUTOR) {
    return copy(EXECUTOR_SKILLS);
  }

  return [];
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/skills/skills.ts